import styled from "@emotion/styled";

/**
 * A styled container for the date bar markers.
 */
export const TimelineDateBarContainer = styled.div( {
    position: "relative",
    width: "100%",
    height: "30px",
} );

/**
 * A styled row for the date bars.
 */
export const BarRow = styled.div( {
    display: "flex",
    flexDirection: "row",
    position: "relative",
} );

/**
 * A styled bar element.
 */
export const Bar = styled.div<{ left: number, textColor: string }>( ( { left, textColor } ) => ( {
    width: "2px",
    height: "30px",
    backgroundColor: textColor,
    position: "absolute",
    left: `${left}%`,
} ) );

/**
 * A styled label for the date represented by the space between dateBar elements.
 */
export const BarLabel = styled.div<{ left: number }>( ( { left } ) => ( {
    position: "absolute",
    left: `${left}%`,
    fontSize: "12px",
    transform: "translateX(-50%)",
    whiteSpace: "nowrap",
    textAlign: "center",
    marginTop: "5px",
} ) );
